import type { Fanpage, Group } from '../../shared/types';

interface TopicRule {
  topic: string;
  keywords: string[];
}

// ---------------------------------------------------------------------------
// FANPAGE — 8 chủ đề lớn, phân tích theo nội dung trang
// ---------------------------------------------------------------------------
const FANPAGE_TOPIC_RULES: TopicRule[] = [
  {
    topic: '🎵 Âm nhạc & Giải trí',
    keywords: [
      'music', 'nhạc', 'nonstop', 'âm nhạc', 'ca sĩ', 'trạm nhạc',
      'entertainment', 'media', 'tv', 'monstar', 'galaxy',
    ],
  },
  {
    topic: '🎬 Phim & Truyện',
    keywords: [
      'phim', 'movie', 'truyện', 'review', 'rì viu', 'riền', 'mọt',
      'gác truyện', 'tiệm truyện', 'chợ truyện', 'góc truyện', 'đồng truyện',
      'truyện ngon', 'truyện xinh', 'truyện hay', 'nhà kể chuyện',
      'nghiền phim', 'phim hay', 'phim 24h', 'vui tv', 'golam',
    ],
  },
  {
    topic: '💕 Ngôn tình & Lãng mạn',
    keywords: [
      'lâu', 'ngôn tình', 'mộng', 'nguyệt', 'tuyết', 'bích', 'tử mộng',
      'u nguyệt', 'tịnh hoa', 'mặc vũ', 'dạ phong', 'vạn duyên', 'phù sinh',
      'vĩnh tình', 'lưu vân', 'thanh ngọc', 'mộng vân', 'bích tâm',
      'phong nguyệt', 'hàn tuyết', 'an nhiên', 'thiên mệnh', 'nhất mộng',
      'duyên ảnh', 'trúc nguyệt', 'hoa nguyệt', 'vân mộng', 'mộng tình',
    ],
  },
  {
    topic: '🌟 K-pop & Idol',
    keywords: [
      'kpop', 'korea', 'drama', 'jungkook', 'taehyung', 'taekook', 'vkook',
      'bangtan', 'bts', 'got7', 'mark tuan', 'ji chang wook', 'seokjin',
      'yoongi', 'namjoon', 'suga', 'elf', 'luhan', 'tao', 'kumamon',
      'chu dực nhiên', 'trương miểu di', 'cúc tịnh y', 'triệu lệ dĩnh',
      'methun', 'seung na', 'startlight', 'santa', 'rikimaru',
    ],
  },
  {
    topic: '📰 Tin tức & Cộng đồng',
    keywords: [
      'tin tức', 'hóng', '24h', 'điểm tin', 'đời sống', 'pháp luật',
      'tâm điểm', 'giao thông', 'thời sự', 'quotes', 'news', 'phố news',
      'văn hóa', 'cộng đồng', 'sáng tạo', 'thú vị',
    ],
  },
  {
    topic: '🛍️ Mua sắm & Kinh doanh',
    keywords: [
      'shop', 'mart', 'xưởng', 'tạp hoá', 'hàng úc', 'nước hoa',
      'thẻ tín dụng', 'sạp card', 'in ảnh', 'đồ ngủ', 'store', 'boutique',
      'kinh doanh', 'bán hàng',
    ],
  },
  {
    topic: '💪 Sức khỏe & Làm đẹp',
    keywords: [
      'getfit', 'sức khỏe', 'làm đẹp', 'điều trị', 'xương khớp', 'spa',
      'gym', 'fitness', 'beauty', 'skincare', 'hương giang',
    ],
  },
  {
    topic: '😄 Lifestyle & Ẩm thực',
    keywords: [
      'ẩm thực', 'ham ăn', 'đói không', 'nấu ăn', 'food', 'ăn vặt',
      'lifestyle', 'cuộc sống', 'góc nhỏ', 'oops', 'omelet', 'lượn',
      'mắt trong veo', 'dọn nhà', 'ở đây', 'hôm nay', 'ngày mai',
      'tâm sự', 'genz', 'béo mà cháy', 'nhớ', 'buồn', 'vui',
    ],
  },
];

// ---------------------------------------------------------------------------
// GROUP — 10 chủ đề lớn, phân tích theo loại nhóm
// ---------------------------------------------------------------------------
const GROUP_TOPIC_RULES: TopicRule[] = [
  {
    topic: '🛒 Chợ & Mua bán',
    keywords: [
      'chợ', 'mua bán', 'rao vặt', 'trao đổi', 'sỉ lẻ', 'sỉ', 'lẻ',
      'thanh lý', 'pass đồ', 'đồ cũ', '2hand', 'secondhand', 'hàng thùng',
      'hàng si', 'bán đồ', 'nguồn hàng', 'ôm lô',
    ],
  },
  {
    topic: '💼 Việc làm & Tuyển dụng',
    keywords: [
      'việc làm', 'tuyển dụng', 'tuyển', 'kcn', 'khu công nghiệp',
      'công nhân', 'lao động', 'nhân sự', 'parttime', 'fulltime',
      'tìm việc', 'tuyển lao động', 'thời vụ',
    ],
  },
  {
    topic: '🏘️ Cộng đồng địa phương',
    keywords: [
      'người', 'dân', 'đồng hương', 'quê', 'huyện', 'phường', 'xã',
      'tôi là dân', 'cư dân', 'khu vực', 'tỉnh', 'thành phố',
      'hà nội', 'hồ chí minh', 'đà nẵng', 'cần thơ', 'hải phòng',
    ],
  },
  {
    topic: '🏠 Bất động sản & Nhà ở',
    keywords: [
      'bất động sản', 'nhà đất', 'cho thuê', 'phòng trọ', 'căn hộ',
      'chung cư', 'mặt bằng', 'vinhomes', 'homestay', 'nhà nguyên căn',
      'sang nhượng', 'mua bán nhà',
    ],
  },
  {
    topic: '🚗 Xe cộ & Phương tiện',
    keywords: [
      'xe', 'ô tô', 'honda', 'toyota', 'kia', 'hyundai', 'ford', 'mazda',
      'mitsubishi', 'vinfast', 'nissan', 'mercedes', 'chevrolet', 'yamaha',
      'exciter', 'vario', 'air blade', 'moto', 'pkl', 'xe đạp', 'xe điện',
      'biển số', 'xe máy', 'xe ghép', 'tiện chuyến',
    ],
  },
  {
    topic: '🌾 Nông sản & Thực phẩm',
    keywords: [
      'nông sản', 'sầu riêng', 'cà phê', 'dược liệu', 'thảo dược',
      'hoa quả', 'măng', 'nha đam', 'tôm', 'dừa', 'yến sào', 'đông trùng',
      'hạt dinh dưỡng', 'hải sản', 'gà', 'vịt', 'ngan', 'thực phẩm',
      'nông dân', 'trồng', 'nuôi',
    ],
  },
  {
    topic: '👗 Thời trang & Làm đẹp',
    keywords: [
      'thời trang', 'quần áo', 'giày', 'túi xách', 'mỹ phẩm', 'son',
      'trang sức', 'vàng', 'bạc', 'đồng hồ', 'nước hoa', 'váy đầm',
      'nail', 'tóc', 'spa', 'thẩm mỹ', 'làm đẹp', 'local brand',
      'hàng hiệu', 'luxury',
    ],
  },
  {
    topic: '📚 Giáo dục & Sức khỏe',
    keywords: [
      'gia sư', 'giáo viên', 'luyện thi', 'ielts', 'tiếng anh', 'tiếng hàn',
      'tiếng trung', 'mầm non', 'tiểu học', 'can thiệp', 'tự kỷ', 'chậm nói',
      'stem', 'giảm cân', 'sức khỏe', 'điều dưỡng', 'y tế', 'trầm cảm',
      'tăng cân', 'eatclean', 'yoga', 'massage', 'học',
    ],
  },
  {
    topic: '💻 Công nghệ & Kinh doanh online',
    keywords: [
      'laptop', 'macbook', 'iphone', 'điện thoại', 'pc', 'linh kiện',
      'máy in', 'công nghệ', 'ai', 'tiktok', 'shopee', 'affiliate',
      'designer', 'pod', 'dropship', 'kiếm tiền online', 'marketing',
      'freelancer', 'it remote',
    ],
  },
  {
    topic: '🍜 Ẩm thực & Giải trí',
    keywords: [
      'ăn vặt', 'ăn uống', 'cafe', 'trà sữa', 'trà chanh', 'pha chế',
      'quán', 'đồ uống', 'nấu ăn', 'thực đơn', 'game', 'gaming',
      'free fire', 'liên minh', 'valorant', 'honkai', 'play together',
      'mua bán acc', 'du lịch', 'camping', 'tour',
    ],
  },
];

// ---------------------------------------------------------------------------
// Core logic — fallback về "Khác" thay vì bóc tách tên
// ---------------------------------------------------------------------------
function classifyByRules(name: string, rules: TopicRule[], fallback: string): string {
  const lower = ` ${name.toLowerCase()} `;
  for (const rule of rules) {
    for (const kw of rule.keywords) {
      if (lower.includes(` ${kw.toLowerCase()} `) || lower.includes(kw.toLowerCase())) {
        return rule.topic;
      }
    }
  }
  return fallback;
}

export function classifyFanpageTopic(name: string): string {
  return classifyByRules(name, FANPAGE_TOPIC_RULES, '✨ Khác');
}

export function classifyGroupTopic(name: string): string {
  return classifyByRules(name, GROUP_TOPIC_RULES, '🔖 Khác');
}

export function getUniqueFanpageTopics(fanpages: Fanpage[]): string[] {
  const topics = new Set<string>();
  for (const fp of fanpages) {
    topics.add(classifyFanpageTopic(fp.name));
  }
  // Sort with defined order first, then alphabetically
  const order = FANPAGE_TOPIC_RULES.map(r => r.topic);
  return Array.from(topics).sort((a, b) => {
    const ia = order.indexOf(a);
    const ib = order.indexOf(b);
    if (ia >= 0 && ib >= 0) return ia - ib;
    if (ia >= 0) return -1;
    if (ib >= 0) return 1;
    return a.localeCompare(b, 'vi');
  });
}

export function getUniqueGroupTopics(groups: Group[]): string[] {
  const topics = new Set<string>();
  for (const g of groups) {
    topics.add(classifyGroupTopic(g.name));
  }
  const order = GROUP_TOPIC_RULES.map(r => r.topic);
  return Array.from(topics).sort((a, b) => {
    const ia = order.indexOf(a);
    const ib = order.indexOf(b);
    if (ia >= 0 && ib >= 0) return ia - ib;
    if (ia >= 0) return -1;
    if (ib >= 0) return 1;
    return a.localeCompare(b, 'vi');
  });
}
